export default [

  {
    path: "/receipts/list",
    name: "receipts-list",
    component: () => import("@/views/receipt/receipts-list/receiptsList.vue"),
    meta: {
      action: ['read', 'read_all'], 
      resource: "receipts",
    },
  },
  {
    path: "/receipt/edit/:id",
    name: "receipt-edit",
    component: () => import("@/views/receipt/receipt-edit/receiptEdit.vue"),
    meta: {
      action: "update",
      resource: "receipts",
    },
  },
  {
    path: "/receipt/copy/:id",
    name: "receipt-copy",
    component: () => import("@/views/receipt/receipt-edit/receiptEdit.vue"),
    meta: {
      action: "create",
      resource: "receipts",
    },
  },
  {
    path: "/receipt/create",
    name: "receipt-create",
    component: () => import("@/views/receipt/receipt-edit/receiptEdit.vue"),
    meta: {
      action: "create",
      resource: "receipts",
    },
  },
  {
    path: '/receipt/preview/:id',
    name: 'receipt-preview',
    component: () => import('@/views/receipt/receipt-preview/ReceiptPreview.vue'),
    meta: {
      action: 'print',
      resource: 'receipts',
    },
  },
]